import React, { useState } from "react";
import { Collapse } from "antd";
import Panelheader from "../../features/panelheader/panelheader";
const { Panel } = Collapse;

const Panels = ({ panels = [{ title: "", text: "" }] }) => {
  const [activeKeys, setActiveKeys] = useState([]);
  const onChange = (e) => {
    setActiveKeys(e);
  };
  return (
    <Collapse onChange={onChange} ghost style={{ width: "100%" }}>
      {panels.map((panel, index) => (
        <Panel
          showArrow={false}
          header={
            <Panelheader
              _index={index}
              _activekeys={activeKeys}
              _title={`${index + 1}. ${panel.title}`}
            />
          }
          key={index}
          style={{ textAlign: "start" }}
        >
          <p>{panel.text}</p>
        </Panel>
      ))}
    </Collapse>
  );
};

export default Panels;
